module.exports = __webpack_public_path__ + "img/inboxes-fill.1ca486f3.svg";